module.exports = __webpack_public_path__ + "static/media/ksiazki_1000X1000.f1654c3b.jpg";